import { z } from 'zod';
import type { PermissionsTree } from '@/shared/types/api/roles';

export const roleFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'roles.form.errors.nameRequired')
    .max(80, 'roles.form.errors.tooLong'),
  permissions: z.array(z.string()).default([]),
});

export type RoleFormValues = z.infer<typeof roleFormSchema>;

/** Walk a `PermissionsTree`, yielding every leaf permission path in dotted form. */
export const collectLeafPaths = (tree: PermissionsTree, prefix = ''): string[] => {
  const out: string[] = [];
  for (const [key, value] of Object.entries(tree)) {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value === true) {
      out.push(path);
    } else {
      out.push(...collectLeafPaths(value, path));
    }
  }
  return out;
};
